<template>
  <div class="room__wrapper flex flex-wrap mb-[-15px]">
    <div class="room w-[294px]" v-for="(room, roomIndex) in rooms" :key="roomIndex">
      
      <CruiseDetailInformation
        :introduction="room.introduction"
        :path="room.path"
        :styles="{ width: '283px', height: '350px', right: '5px', top: '5px' }"
      >
        <template #default="{ path }">
          <el-image class="w-full h-50 block cursor-pointer" fit="cover" :src="path" lazy
            @click="$emit('tapImage', path)">
            <template #error>
              <div class="image-slot">
                <img src="@/assets/img/company/cruise-detail/placeholder-icon.png" />
                <span class="">加载失败</span>
              </div>
            </template>
          </el-image>
        </template>
        <template #footer>
          <div class="flex-1 px-[18px] py-5 overflow-hidden relative h-[164px]">
            <h5 class="text-[17px] text-black font-500 mb-6 leading-6  leading-[24px] line-clamp-2">
              {{ room.name }}
            </h5>
            <ul class="flex flex-wrap text-center  text-xs -mr-[6px] -mb-[7px]">
              <template v-if="type === 'cabin'">
                <li class="mr-[6px] mb-[7px] leading-[22px] px-1 rounded-sm bg-[#F4F4F4] text-[#606370]">
                  <span class="mb-[8px]">代码</span>
                  <span>{{ room.code || "-" }}</span>
                </li>
                <li class="mr-[6px] mb-[7px] leading-[22px] px-1 rounded-sm bg-[#F4F4F4] text-[#606370]">
                  <span class="mb-[8px]">入住人数</span>
                  <span>{{ room.min_people }}-{{ room.max_people }}
                    {{ room.max_people ? "人" : "" }}</span>
                </li>
                <li class="mr-[6px] mb-[7px] leading-[22px] px-1 rounded-sm bg-[#F4F4F4] text-[#606370]">
                  <span class="mb-[8px]">面积</span>
                  <span>{{ room.area || "-" }}㎡</span>
                </li>
                <li class="mr-[6px] mb-[7px] leading-[22px] px-1 rounded-sm bg-[#F4F4F4] text-[#606370]">
                  <span class="mb-[8px]">窗型</span>
                  <span>{{ room.window_type_label || "-" }}</span>
                </li>
              </template>
              <template v-else-if="type == 'restaurants' || type == 'plays'">
                <li class="mr-[6px] mb-[7px] leading-[22px] px-1 rounded-sm bg-[#F4F4F4] text-[#606370]">
                  <span class="mb-[8px]">容纳人数</span>
                  <span>{{ room.capacity ? room.capacity + '人': "-" }} </span>
                </li>
                <li class="mr-[6px] mb-[7px] leading-[22px] px-1 rounded-sm bg-[#F4F4F4] text-[#606370]">
                  <span class="mb-[8px]">开放时间</span>
                  <span>{{ room.open_time || '-' }}</span>
                </li>
                <li class="mr-[6px] mb-[7px] leading-[22px] px-1 rounded-sm bg-[#F4F4F4] text-[#606370]">
                  <span class="mb-[8px]">消费</span>
                  <span>{{ room.consumption || '-' }}</span>
                </li>
              </template>
              <template v-else-if="type == 'services'">
                <li class="mr-[6px] mb-[7px] leading-[22px] px-1 rounded-sm bg-[#F4F4F4] text-[#606370]">
                  <span class="mb-[8px]">开放时间</span>
                  <span>{{ room.open_time || '-' }}</span>
                </li>
                <li class="mr-[6px] mb-[7px] leading-[22px] px-1 rounded-sm bg-[#F4F4F4] text-[#606370]">
                  <span class="mb-[8px]">消费</span>
                  <span>{{ room.consumption || '-' }}</span>
                </li>
              </template>
              <li class="mr-[6px] mb-[7px] leading-[22px] px-1 rounded-sm bg-[#F4F4F4] text-[#606370]">
                <span class="mb-[8px]">所属甲板</span>
                <span v-if="room.floor && room.floor.length">{{ room.floor.join(",") }}层</span>
              </li>
            </ul>
          </div>
        </template>
      </CruiseDetailInformation>
    </div>
  </div>
</template>

<script>
import CruiseDetailInformation from "@/views/company/components/CruiseDetailIntroduction.vue";

export default {
  name: "CruiseDetailCabinRoomThree",
  components: {
    CruiseDetailInformation,
  },
  props: {
    rooms: {
      type: Array,
      default: () => [],
    },
    type:{
      type: String,
      default:'cabin'
    }
  },
};
</script>

<style lang="scss" scoped>
.room {
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.13);
  margin-right: 17px;
  margin-bottom: 15px;
}
.room__wrapper {
  width: 940px;
}
::v-deep .room .image-slot {
  background: url("@/assets/img/company/cruise-detail/placeholder-cruise.png") no-repeat center center;
  background-size: 100% 100%;
  font-size: 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-weight: 500;
  height: 100%;
  text-align: center;
  width: 100%;
}
::v-deep .room .image-slot img {
  height: 38px;
  width: 40px;
}
::v-deep .room .image-slot span {
  display: inline-block;
  margin-top: 7px;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
</style>
